import React, { useEffect, useState } from 'react';
import { getKajabiOfferLists } from '../services/kajabiService';
import { LuCrown } from "react-icons/lu";

export default function UpgradeRequired() {
    const [kajabiOffers, setKajabiOffers] = useState([]);
    const proPlansIDs = [2150878439, 2150878445]; // [Pro Plan, Premium Plan]

    /* User Information */
    useEffect(() => {
        async function fetchDataKajabiOffers() {
            const res = await getKajabiOfferLists();
            const data = res;

            const filtered = data.filter((offer) =>
                proPlansIDs.includes(Number(offer.id))
            );

            setKajabiOffers(filtered);
        }

        fetchDataKajabiOffers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="upgrade-plan-container">
            <span className="upgr-icon"><LuCrown /></span>
            <h2>Upgrade to Premium or Pro</h2>
            <p>It looks like you don't have access to ARI's features yet. Upgrade to Premium or Pro now! <br /> 
            Accelerate Growth With Support For those ready to engage deeper with coaching, expanded tools, and guided development.</p>

            <div className="upgrade-plan-wrapper">
                <ul className='upgr-plan-lists'>
                    {kajabiOffers.map((offer, index) => (
                        <li key={offer.id || index}>
                            <a href={offer.attributes.checkout_url} target='_blank' rel='noopener noreferrer' className='upgr-card-plan'>
                                <div className="upgr-img" style={{backgroundImage: `url('${offer.attributes.image_url}')`}}></div>
                                <div className="upgr-content">
                                    <h3>{offer.attributes.internal_title}</h3>
                                    <div className="upgr-desc">
                                        <p>{offer.attributes.description?.replace(/<[^>]*>/g, ' ')}</p>
                                    </div>
                                    <span>Upgrade to Premium Plan</span>
                                </div>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
